import {SingletonService} from '@/common/dependency.configs'
import {injectable} from 'inversify'

@SingletonService
@injectable()
class FormatFactory {
  currency(input: number | string) {
    const num = +input
    if (!isNaN(num)) {
      return num.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
    }
    return 'NaN'
  }
}
export default FormatFactory
